import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { Editor } from "@tinymce/tinymce-react";
import { classicSettings3, expoSettings, inlineSettings3 } from "./tinyconfig";
import { TinyMCE } from "tinymce";
const  getGlobal = function () { return (typeof window !== 'undefined' ? window : global); };
const setTinymce = function () {
    var global = getGlobal();
    if(global && !global.tinymce)
      global.tinymce = TinyMCE;
};

const ExhibitorEditor = (props) => {
  const [editor, setEditor] = useState({});
  const [cycleEditor, setCycleEditor] = useState(false);
  const [archiveOpen, setArchiveOpen] = useState(false);
  const [linkHelperOpen, setLinkHelperOpen] = useState(false);
  setTinymce();
  useEffect(() => {
    if (cycleEditor) setCycleEditor(false);
  }, [cycleEditor]);

  const onInit = (editor) => setEditor(editor);
  const handleKeyUp = () => {
    const { value, globalFormat, onChange, path, slimFormat } = props;
    var content = editor.getContent();

    if (content !== value) {
      if (globalFormat === true) {
        onChange(null, content, path);
      } else if (slimFormat === true) {
        onChange(content, path);
      } else {
        onChange(content);
      }
    }
  };
  const formatImage = () => {
    const content = editor.getContent();
    props.onChange(content);
  };
  const onArchiveUseSelect = (url) => {
    var image = new Image();
    image.crossOrigin = "anonymous"; /* THIS WILL MAKE THE IMAGE CROSS-ORIGIN */
    image.src = url;
    let content = editor.insertContent(`<img src="${image.src}"  alt="_blank" height="auto" width="100%" /> `);
    content = editor.getContent();
    props.onChange(content);
  };
  const onLinkSelect = (url) => {
    let content = editor.insertContent(`<a href=${url}  target="blank"  /> `);
    content = editor.getContent();
  };
  const { style, value, sourceCode = true, onChange, user, inline = true, expo = false, height, classic = false, showLinkEditor = true } = props;
  let tBarCode = inlineSettings3.toolbar;
  if (sourceCode) tBarCode = "code |" + tBarCode;
  if (showLinkEditor) tBarCode = tBarCode + "| linkHelper";
  return (
    <>
      <Editor
        /*   initialValue={value} */
        value={value}
        onInit={(event, editor) => onInit(editor, user && user.userLang)}
        disabled={false}
        init={{
          ...classicSettings3,
          content_style: style,
          width: "100%",
          height: 500,
        }}
        onEditorChange={(e) => handleKeyUp()}
      />
    </>
  );
};

function mapStateToProps(state) {
  return {
    user: state.authentication.user,
  };
}
export default connect(mapStateToProps)(ExhibitorEditor);
